import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Link as LinkScroll } from 'react-scroll';
import ButtonBase from '../../Buttons/ButtonBase';
import './FreemiumOnline.scss';

const useStyles = makeStyles({
    container: {
        justifyContent: 'center'
    },
    buttonStyle: {
        minWidth: 293,
    }
})

const FreemiumOnline = () => {
    
    const classes = useStyles()

    return (
        <section className="FreemiumOnline">
            <div className='FreemiumOnline_imgContainer'>
                <img
                    className='FreemiumOnline_imgContainer-img'
                    src='/img/freemiumMembershipLanding/Online/videocall.png'
                    alt='videocall'
                />
            </div>
            <div className='FreemiumOnline_blueContainer'>
                <p className='FreemiumOnline_blueContainer-title'>
                    Compruebe que estar en línea le brinda
                    la posibilidad de ofrecer sus servicios
                    legales a más personas.
                </p>
                <p className='FreemiumOnline_blueContainer-subtitle'>
                    Agende una videollamada con uno
                    de nuestros especialistas digitales
                    y conozca los beneficios que
                    tenemos para usted.
                </p>
                <div class="FreemiumOnline_buttonContainer">
                    <LinkScroll to="freemiumForm" smooth="true" duration={500} offset={-60}>
                        <ButtonBase
                            type="submit"
                            variant="secondary"
                            linkStyle={classes.linkStyle}
                            buttonStyle={classes.buttonStyle}
                        >
                            Conviértase en un abogado digital
                        </ButtonBase>
                    </LinkScroll>
                </div>
            </div>
        </section>
     );
}
 
export default FreemiumOnline;